import rest from "@/rest-client";
import createCustomSaveVuexModule from "@/store/customSaveStore";

const updateForm = {
  editOption: "ADD",
  directCollectMethods: [],
  otherCollectMethods: [],
  physicalStorages: [],
  electronicStorages: [],
  physicalArchives: [],
  electronicArchives: [],
  transferings: [],
  processingLegals: [],
  accessAndRestrictions: [],
  datasubjectRights: [],
  disposalMethods: [],
  disposalPeriod: 0,
  autoProcessing: undefined,
};

const inventoryBulkUpdateStore = {
  namespaced: true,

  state: {
    isUpdating: false,
    updateForm: {
      ...updateForm,
    },
  },
  getters: {
    updateForm: (state) => state.updateForm,
  },
  mutations: {
    reset: (state, value) => (state.updateForm = { ...state.updateForm, ...updateForm }),
    isUpdating: (state, value) => (state.updateForm.isUpdating = value),
    editOption: (state, value) => (state.updateForm.editOption = value),
    disposalPeriod: (state, value) => (state.updateForm.disposalPeriod = value),
    autoProcessing: (state, value) => (state.updateForm.autoProcessing = value),

    setDirectCollectMethods: (state, values) => (state.updateForm.directCollectMethods = [...values]),
    removeDirectCollectMethod: (state, value) => {
      state.updateForm.directCollectMethods = state.updateForm.directCollectMethods.filter((i) => i._id != value._id);
    },

    setOtherCollectMethods: (state, values) => (state.updateForm.otherCollectMethods = [...values]),
    removeOtherCollectMethod: (state, value) => {
      state.updateForm.otherCollectMethods = state.updateForm.otherCollectMethods.filter((i) => i._id != value._id);
    },

    addPhysicalStorage: (state, value) => {
      state.updateForm.physicalStorages = [...state.updateForm.physicalStorages.filter((i) => i.libraryItem._id != value.libraryItem._id), value];
    },
    setPhysicalStorages: (state, values) => {
      state.updateForm.physicalStorages = [...values];
    },
    removePhysicalStorage: (state, value) => {
      state.updateForm.physicalStorages = state.updateForm.physicalStorages.filter((i) => i.libraryItem._id != value.libraryItem._id);
    },

    addElectronicStorage: (state, value) => {
      state.updateForm.electronicStorages = [...state.updateForm.electronicStorages.filter((i) => i.libraryItem._id != value.libraryItem._id), value];
    },
    setElectronicStorages: (state, values) => {
      state.updateForm.electronicStorages = [...values];
    },
    removeElectronicStorage: (state, value) => {
      state.updateForm.electronicStorages = state.updateForm.electronicStorages.filter((i) => i.libraryItem._id != value.libraryItem._id);
    },

    setPhysicalArchives: (state, values) => (state.updateForm.physicalArchives = [...values]),
    removePhysicalArchive: (state, value) => {
      state.updateForm.physicalArchives = state.updateForm.physicalArchives.filter((i) => i._id != value._id);
    },

    setElectronicArchives: (state, values) => (state.updateForm.electronicArchives = [...values]),
    removeElectronicArchive: (state, value) => {
      state.updateForm.electronicArchives = state.updateForm.electronicArchives.filter((i) => i._id != value._id);
    },

    addAccessAndRestriction: (state, value) => {
      state.updateForm.accessAndRestrictions = [...state.updateForm.accessAndRestrictions.filter((i) => i.accessor._id != value.accessor._id), value];
    },
    setAccessAndRestrictions: (state, values) => {
      state.updateForm.accessAndRestrictions = [...values];
    },
    removeAccessAndRestriction: (state, value) => {
      state.updateForm.accessAndRestrictions = state.updateForm.accessAndRestrictions.filter((i) => i.accessor._id != value.accessor._id);
    },

    addProcessingLegal: (state, value) => {
      state.updateForm.processingLegals = [
        ...state.updateForm.processingLegals.filter((i) => {
          return !(i.legalReason.libraryItem._id == value.legalReason.libraryItem._id && i.purpose.libraryItem._id == value.purpose.libraryItem._id);
        }),
        value,
      ];
    },
    setProcessingLegals: (state, values) => {
      state.updateForm.processingLegals = [...values];
    },
    removeProcessingLegal: (state, value) => {
      state.updateForm.processingLegals = state.updateForm.processingLegals.filter((i) => {
        return !(i.legalReason.libraryItem._id == value.legalReason.libraryItem._id && i.purpose.libraryItem._id == value.purpose.libraryItem._id);
      });
    },

    addTransfering: (state, value) => {
      state.updateForm.transferings = [...state.updateForm.transferings.filter((i) => i._id != value._id), value];
    },
    setTransferings: (state, values) => {
      state.updateForm.transferings = [...values];
    },
    removeTransfering: (state, value) => {
      state.updateForm.transferings = state.updateForm.transferings.filter((i) => i._id != value._id);
    },

    setDatasubjectRights: (state, values) => (state.updateForm.datasubjectRights = [...values]),
    removeDatasubjectRight: (state, value) => {
      state.updateForm.datasubjectRights = state.updateForm.datasubjectRights.filter((i) => i._id != value._id);
    },

    setDisposalMethods: (state, values) => (state.updateForm.disposalMethods = [...values]),
    removeDisposalMethod: (state, value) => {
      state.updateForm.disposalMethods = state.updateForm.disposalMethods.filter((i) => i._id != value._id);
    },
  },
  actions: {
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);

        const response = await rest.put("/gdpr/inventory/bulk-update", { request: payload });

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
};

export const kvkkInventoryBulkUpdate = createCustomSaveVuexModule({
  ...inventoryBulkUpdateStore,
  path: "/kvkk/inventory/bulk-update",
});

export const gdprInventoryBulkUpdate = createCustomSaveVuexModule({
  ...inventoryBulkUpdateStore,
  path: "/gdpr/inventory/bulk-update",
});
